
import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import MainLayout from './MainLayout';
import './LayoutSelector.css';

const LayoutSelector = ({ children }) => {
  const { currentUser, loading } = useAuth();
  const [isReady, setIsReady] = useState(false);
  const prevUserRef = useRef();

  useEffect(() => {
    // Store the current user's state to compare on the next render
    prevUserRef.current = currentUser;
  });

  const prevUser = prevUserRef.current;

  // Determine if the transition is a user logging in. This is key for the timing.
  // A login occurs when there was no user previously, but now there is.
  const isLoginTransition = !prevUser && currentUser;
  const animationClass = isLoginTransition ? 'fade-in-slow' : 'fade-in-fast';

  useEffect(() => {
    if (!loading) {
      // The 100ms delay is crucial to prevent flicker by ensuring the auth state is stable.
      const timer = setTimeout(() => {
        setIsReady(true);
      }, 100);

      return () => clearTimeout(timer);
    } else {
      setIsReady(false);
    }
  }, [loading, currentUser]); // Rerun effect if user or loading state changes

  // Show the enhanced loading screen if auth is in progress or during our brief delay.
  if (loading || !isReady) {
    return (
      <div className="loading-fullscreen">
        <div className="spinner"></div>
        <span>Loading...</span>
      </div>
    );
  }

  // Render the appropriate layout with the correct animation class.
  return (
    <div className={`layout-container ${animationClass}`}>
      {currentUser ? <MainLayout>{children}</MainLayout> : <>{children}</>}
    </div>
  );
};

export default LayoutSelector;
